import { primaryColor } from './colors';
import { cssBaseline } from './cssBaseline';

export const overrides = (theme) =>( {
    MuiButton:{
      styleOverrides:{
        root: {
          textTransform: 'none',
          borderRadius: '20px',
          padding: '8px 30px',
          fontWeight: 'bold',
        },
        containedPrimary: {
          backgroundColor: '#F3B133',
          color: 'white',
          '&:hover': {
            backgroundColor: '#eba119ff',
          },
        },
        containedSecondary: {
          backgroundColor: primaryColor,
          color: 'white',
          '&:hover': {
            backgroundColor: '#4d3ea0ff',
          },
        },
        contained: {
          backgroundColor: '#F3B133', 
          color: 'white',
          fontSize:'1rem',
          '&:hover': {
            backgroundColor: '#eba119ff', 
          },
        },
      }
    },
    MuiOutlinedInput:{
      styleOverrides:{
        root:{
          borderRadius: '50px',
          backgroundColor: '#FFFFFF'
        },
        notchedOutline: {
          border: 'none',
        },
        input: {
          padding: '10px 20px',
        },
      }
    },
    MuiInputLabel:{
      styleOverrides:{
        root:{
          color: primaryColor,
          fontWeight: 600,
          transform: 'translate(14px, 0) scale(1)',
          position: 'relative',
          marginBottom: 8,
          fontSize: '1rem',
          
        }
      }
    },
    MuiCssBaseline:cssBaseline(theme) 
})